import React, { createContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  CatchMessage,
  JSONtoformdata,
  tokenisValid,
} from "../../Shared/Methods";
import {
  DeleteDeviceAlertSettings,
  DropdownService,
  ListDeviceAlertSettings,
  PublishConfigService,
} from "../../Services/ApiServices";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import Createdevicealertsmodal from "../../Modals/Device/CreateDeviceAlertsmodal";
import Relayalert from "./RelayAlert";
import Pininputalert from "./PinInputAlert";
import Parameteralert from "./ParameterAlert";
import Loader from "../../SharedComponents/Loader/Loader";
import CommonButton from "../Buttons/CommonButton";
import Publishconfig from "../../Modals/Device/PublishConfig";
import DeleteConfirmation from "../../Modals/DeleteConfirmation";
import { Col, Row } from "antd";

interface props {
  data: any;
  Getlist: (page: number, size: number, fortype: string) => void;
  listData: any;
  DropDowns: any;
  Dropdown: any;
  DeleteItem: any;
  handleCancel: () => void;
}

export const context = createContext<props | null>(null);

function Devicealertsettings({ item }: { item?: any }) {
  const { loading } = useSelector((state: any) => state.Dashboard);
  const [showmodal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { LoginData } = useSelector((state: any) => state.Auth);

  const [listAlertData, setListAlertData] = useState<any>({
    RelayData: [],
    InputData: [],
    ParameterData: [],
  });
  const [pageSize, setpageSize] = useState(10);
  const [pageind, setPageInd] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState<any>({
    isView: false,
    item: "",
    Itemname: "",
    fortype: "",
    page: 1,
    size: 10,
  });

  const [DropDowns, setDropDowns] = useState({
    Relay: [],
    InputPin: [],
    Parameter: [],
    Meter: [],
    isRelayLoading: true,
    isInputLoading: true,
    isParameterLoading: true,
    isMeterLoading: true,
  });
  const [isConfig, setConfig] = useState(false);

  const handleListAllerts = (page = 1, size = 10, fortype = "") => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: item?.deviceId,
      for_type: fortype,
    };

    ListDeviceAlertSettings(JSONtoformdata(finalObj), page, size)
      .then(async (res) => {
        if (res.data.status === 1) {
          if (fortype === "2") {
            //relay
            setListAlertData((pre: any) => {
              return {
                ...pre,
                RelayData: res?.data?.data,
              };
            });
            setPageInd(page > 1 ? page - 1 : 0);
          } else if (fortype === "3") {
            //inputpin
            setListAlertData((pre: any) => {
              return {
                ...pre,
                InputData: res?.data?.data,
              };
            });
            setPageInd(page > 1 ? page - 1 : 0);
          } else if (fortype === "1") {
            //parameter
            setListAlertData((pre: any) => {
              return {
                ...pre,
                ParameterData: res?.data?.data,
              };
            });
            setPageInd(page > 1 ? page - 1 : 0);
          }
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getInputPinDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      for_alert: 1,
      device_id: item?.deviceId,
    };
    DropdownService(JSONtoformdata(finalObj), "pinDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isInputLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              InputPin: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isInputLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getRelayDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      for_alert: 1,
      device_id: item?.deviceId,
    };
    DropdownService(JSONtoformdata(finalObj), "relayDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isRelayLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Relay: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isRelayLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getParameterDropDown = (meterid: any) => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: item?.deviceId,
      meter_id: meterid,
    };
    DropdownService(JSONtoformdata(finalObj), "parameterDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isParameterLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Parameter: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isParameterLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const getMeterDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: item?.deviceId,
    };
    DropdownService(JSONtoformdata(finalObj), "meterDropdown")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isMeterLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Meter: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isMeterLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const DeleteDevice = (showConfirmModal: any) => {
    const { item, fortype, size } = showConfirmModal;
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      alert_id: item?.id,
      device_id: item?.device_id,
    };
    DeleteDeviceAlertSettings(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          toast.success(res.data.msg);
          setPageInd(
            listAlertData?.items?.length === 1 && listAlertData?.page !== 1
              ? pageind - 1
              : pageind
          );
          handleListAllerts(
            listAlertData?.items?.length === 1 && listAlertData?.page !== 1
              ? listAlertData?.page - 1
              : listAlertData?.page,
            size,
            fortype
          );
          handleCancel();
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => dispatch(handleloading(false)));
  };

  const handlepublish = () => {
    dispatch(handleloading(true));

    const finalObj = {
      token: LoginData?.token,
      for_type: 3,
      status: 1,
      deviceId: item?.deviceId,
    };

    PublishConfigService(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status === 1) {
          toast.success("Success");
          setConfig(false);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })

      .catch((err) => CatchMessage(err))
      .finally(() => dispatch(handleloading(false)));
  };

  const handleCancel = () => {
    setShowConfirmModal({ isView: false, item: "" });
    setShowModal(false);
    setDropDowns((pre: any) => {
      return { ...pre, Parameter: [] };
    });
    setDropDowns((pre) => {
      return {
        ...pre,
        isInputLoading: true,
        isParameterLoading: true,
        isMeterLoading: true,
        isRelayLoading: true,
      };
    });
  };

  return (
    <>
      <Loader isLoader={loading} />
      {showConfirmModal?.isView ? (
        <DeleteConfirmation
          handleSuccess={() => {
            DeleteDevice(showConfirmModal);
          }}
          itemName={showConfirmModal?.Itemname}
          Delete={true}
          open={showConfirmModal?.isView}
          closable={!showConfirmModal?.isView}
          onCancel={handleCancel}
        />
      ) : null}

      {isConfig ? (
        <Publishconfig
          open={isConfig}
          onCancel={() => setConfig(false)}
          closable={!isConfig}
          handleSuccess={() => handlepublish()}
        />
      ) : null}

      {/* not used */}
      {showmodal ? (
        <Createdevicealertsmodal
          open={showmodal}
          closable={!showmodal}
          onCancel={handleCancel}
          handleSuccess={() => {
            handleListAllerts();
          }}
          DropDowns={DropDowns}
          item={item}
          Dropdown={{
            getRelayDropDown,
            getInputPinDropDown,
            getParameterDropDown,
            getMeterDropDown,
          }}
        />
      ) : null}
      {/*  */}

      <context.Provider
        value={{
          data: item,
          Getlist: handleListAllerts,
          listData: listAlertData,
          DropDowns: DropDowns,
          Dropdown: {
            getRelayDropDown,
            getInputPinDropDown,
            getParameterDropDown,
            getMeterDropDown,
          },
          DeleteItem: setShowConfirmModal,
          handleCancel: handleCancel,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            border: "4px solid #20a2a078",
          }}
          className="primarycard"
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ margin: "0" }} className="device_heading_style">
              Alert Settings
            </p>
            <CommonButton
              name="Publish Config"
              onClick={() => {
                setConfig(true);
              }}
              type="button"
              // style={{
              //   padding: "7px 10px",
              //   maxWidth: "158px",
              //   height: "37px",
              //   fontSize: "16px",
              //   color: "white",
              //   backgroundImage:
              //     "linear-gradient(-180deg, rgb(0 181 219), rgb(6 93 102))",
              // }}
              classname="publish_config_button"
            />
          </div>

          <Row gutter={[16, 16]}>
            <Col xxl={12} lg={12} xs={24}>
              <Relayalert />
            </Col>
            <Col xxl={12} lg={12} xs={24}>
              <Pininputalert />
            </Col>
          </Row>

          {/* 2 */}
          {/* <Relayalert /> */}
          {/* 3 */}
          {/* <Pininputalert /> */}
          {/* 1 */}
          <Parameteralert />
        </div>
      </context.Provider>
    </>
  );
}

export default Devicealertsettings;
